import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LSProvider } from './Context/useLSContext';
import { AuthProvider } from 'react-oidc-context';
import { buildMomentAuthConfig } from '@moment-golf/auth';
import { DataProvider } from './Context/useDataContext';
import { HoleSettingsProvider } from './Context/useHoleSettingsContext';
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <DataProvider>
    <LSProvider>
      <HoleSettingsProvider>
        <AuthProvider {...buildMomentAuthConfig({
          authority: process.env.REACT_APP_COGNITO_AUTHORITY ?? '',
          clientId: process.env.REACT_APP_COGNITO_CLIENT_ID ?? '',
          cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN ?? '',
          redirectUri: `${window.location.origin}/login`,
        })}>
          <App />
        </AuthProvider>
      </HoleSettingsProvider>
    </LSProvider>
  </DataProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register the service worker for PWA functionality
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When an update is available, you can show a notification to the user
    const updateConfirm = window.confirm(
      'A new version of the application is available! Click OK to update.'
    );
    
    if (updateConfirm) {
      serviceWorkerRegistration.applyUpdate();
    }
  },
});
